// import React from 'react';
// import replaceDotWithComma from '../../../../helpers/utils/replaceDotWithComma';

// export default function template(context) {
//     const calc = context.calc,
//         model = calc.state.model;

//     return (
//         <React.Fragment>
//             <div className="right-part-info">
//                 <div className="disclaimer">{calc.l10n('CALCULATOR_DISCLAIMER_NEW')}</div>
//                 <div className="main-result">
//                     <p className="monthly-payment">
//                         {calc.l10n("CALCULATOR_MONTHLY_PAYMENT")}
//                     </p>
//                     <p className="monthly-payment-value">
//                         {model.getRequiredPayment().toFixed(2).replace('.', ',').toLocaleString()} {calc.l10n('UAH_LOW_CASE')}
//                     </p>
//                 </div>

//                 <div className={`loan-conditions ${calc.props.type}`}>
//                     <div className="loan-conditions-item">
//                         <p className="condition-text">{calc.l10n('CALCULATOR_CREDIT_SUM_NEW')}
//                             {model.getCreditSum().toLocaleString()} {calc.l10n('UAH_LOW_CASE')}
//                         </p>
//                     </div>
//                     <div className="loan-conditions-item">
//                         <p className="condition-text">{calc.l10n('CALCULATOR_CREDIT_PAYMENTS_NEW')}
//                             {model.getBankCreditTerm()}
//                         </p>
//                     </div>

//                     <div className="loan-conditions-item">
//                         <p className="condition-text">{calc.l10n('CALCULATOR_CREDIT_INSTALLMENT_BASIC_MONTH_COMISSION_NEW')}
//                             {replaceDotWithComma(model.getBasicRate())}{calc.l10n('CALCULATOR_CREDIT_PERCENT')}
//                         </p>
//                     </div>

//                     <div className="loan-conditions-item">
//                         <p className="condition-text">{calc.l10n('CALCULATOR_OVERPAYMENT_NEW')}
//                             {model.getOverpayment().toFixed(2).replace('.', ',').toLocaleString()} {calc.l10n('UAH_LOW_CASE')}
//                         </p>
//                     </div>

//                     <div className="loan-conditions-item">
//                         <p className="condition-text">{calc.l10n('CALCULATOR_REAL_INTEREST_RATE_PBP')}
//                             {model.getRealInterestRate()}
//                         </p>
//                     </div>

//                     <div className="loan-conditions-item">
//                         <p className="condition-text">{calc.l10n('CALCULATOR_TOTAL_COST_NEW')}
//                             {model.getCreditCost().toFixed(2).replace('.', ',').toLocaleString()} {calc.l10n('UAH_LOW_CASE')}
//                         </p>
//                     </div>
//                 </div>
//             </div>

//             <div className="disclaimer">{calc.l10n('CREDIT_PBP_DESIERED_PRESCRIPTION_NEW')}</div>
//         </React.Fragment>
//     );
// }

import React from 'react';
import replaceCommaWithDot from '../../../../helpers/utils/replaceCommaWithDot';

export default function template(context) {
  const calc = context.calc,
    model = calc.state.model;

  return (
    <React.Fragment>
      <div className="loan-conditions-table">
        <div className="loan-conditions-item">
          <div className="condition-title">{calc.l10n('CALCULATOR_MONTHLY_PAYMENT_NEW')}</div>
          <div className="condition-text">{replaceCommaWithDot(model.getRequiredPayment().toLocaleString())} {calc.l10n('UAH_ICON')}</div>
        </div>
        <div className="loan-conditions-item">
          <div className="condition-title">{calc.l10n('CALCULATOR_CREDIT_PAYMENTS')}</div>
          <div className="condition-text">{model.getBankCreditTerm()}</div>
        </div>
        <div className="loan-conditions-item">
          <div className="condition-title">{calc.l10n('CALCULATOR_CREDIT_SUM_NEW_DESIGN')}</div>
          <div className="condition-text">{model.getCreditSum().toLocaleString()} {calc.l10n('UAH_ICON')}</div>
        </div>
        <div className="loan-conditions-item">
          <div className="condition-title">{calc.l10n('CALCULATOR_OVERPAYMENT_AEXPRESS_1')}</div>
          <div className="condition-text">{replaceCommaWithDot(model.getOverpayment().toLocaleString())} {calc.l10n('UAH_ICON')}</div>
        </div>
      </div>
      <div className="loan-conditions-lines">
        <div className="loan-conditions-item">
          <div className="condition-title">{calc.l10n('CALCULATOR_REAL_INTEREST_RATE_NEW_DESIGN_1')}</div>
          <div className="condition-text">{replaceCommaWithDot(model.getRealInterestRate())}{calc.l10n('CALCULATOR_CREDIT_PERCENT')}</div>
        </div>
        <div className="loan-conditions-item">
          <div className="condition-title">{calc.l10n('CALCULATOR_TOTAL_COST')}</div>
          <div className="condition-text">{replaceCommaWithDot(model.getCreditCost().toLocaleString())} {calc.l10n('UAH_ICON')}</div>
        </div>
        <div className="disclaimer" dangerouslySetInnerHTML={{__html: calc.l10n('CALCULATOR_DISCLAIMER_02')}}></div>
      </div>
    </React.Fragment>
  );
}
